import React from "react"
import PropTypes from "prop-types"
import Form from "@bappweb/form"
import Label from "@bappweb/label"
import Currency from "../../../../currency"

const AmountReview = props => {
  return (
    <Form.Group review name="reviewFormGroupAmount">
      <Label text={props.label} id="reviewAccountAmount" />
      <Currency
        value={props.value}
        currency={props.currency}
        size="sm"
        sizeCurrency="sm"
        className="text-right"
      />
    </Form.Group>
  )
}

AmountReview.propTypes = {
  label: PropTypes.string,
  value: PropTypes.number.isRequired,
  currency: PropTypes.oneOf(["TL", "USD", "EUR"]),
}

AmountReview.defaultProps = {
  currency: "TL",
}

export default AmountReview
